module.exports = "<div class=\"slidecontainer\">\r\n  <form>\r\n    <div class=\"row\">\r\n\r\n      <div class=\"col-md-10 order-md-1 mb-4 mb-md-0\">\r\n\r\n          <span *ngIf=\"enabled\">\r\n          {{ range }}\r\n          </span>\r\n\r\n        <div #slider class=\"customProgressBar mt-2 mb-3\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/calendar-hours/calendar-hours.component.html
// module id = ./src/app/shared/components/calendar-hours/calendar-hours.component.html
// module chunks = main